export default "__VITE_ASSET__nBMjhs0G__"